import React from 'react';
import dayjs from 'dayjs';

interface Launch {
  id: string;
  name: string;
  window_start: string;
}

interface Event {
  id: string;
  title: string;
  dateTime: string;
  location?: string;
  htmlLink?: string;
}

interface SpaceEventsDashboardProps {
  allEvents: Event[];
  weeklyLaunchCount: number | null;
  nextThreeLaunches: Launch[];
  isLaunchesLoading: boolean;
  onEventsCardClick: () => void;
}

const SpaceEventsDashboard: React.FC<SpaceEventsDashboardProps> = ({
  allEvents,
  weeklyLaunchCount,
  nextThreeLaunches,
  isLaunchesLoading,
  onEventsCardClick,
}) => {
  return (
    <div className='bg-white rounded-2xl p-4 w-full max-w-[1400px] shadow-lg'>
      <div className='flex items-center gap-4 pb-8 py-4'>
        <div className='w-12 h-12 rounded-xl flex items-center justify-center text-2xl bg-gradient-to-br from-blue-100 to-blue-200'>
          🚀
        </div>
        <div>
          <p className='text-lg font-bold text-slate-800'>Space Watch</p>
        </div>
      </div>

      <div className='bg-slate-50 border border-slate-200 rounded-lg overflow-hidden'>
        <div
          className='flex flex-col gap-3 px-4 pt-4 pb-6 transition-all cursor-pointer relative overflow-hidden h-fit hover:bg-white'
          onClick={onEventsCardClick}
        >
          <div
            style={{ color: '#3b82f6' }}
            className='text-xl font-bold leading-none'
          >
            Major Events: {allEvents.length}
          </div>
          <div className='flex flex-col text-xs text-[#6C6C6C] gap-2 bg-[#F2F2F2] rounded-lg p-2'>
            {allEvents.map((event, index) => (
              <div key={event.id} className=''>
                {index + 1}. {event.title}
              </div>
            ))}
          </div>
        </div>

        <div className='w-[90%] mx-auto border-b border-slate-200'></div>

        <div className='flex flex-col gap-3 px-4 pt-4 pb-6 transition-all cursor-pointer relative overflow-hidden h-fit hover:bg-white'>
          <div
            style={{ color: '#3b82f6' }}
            className='text-xl font-bold leading-none'
          >
            Scheduled Launches:{' '}
            {isLaunchesLoading ? '...' : weeklyLaunchCount ?? '0'}
          </div>
          {nextThreeLaunches.length > 0 && (
            <div className='flex flex-col text-xs text-[#6C6C6C] gap-2 bg-[#F2F2F2] rounded-lg p-2'>
              {nextThreeLaunches.map(launch => (
                <div
                  key={launch.id}
                  className='whitespace-nowrap overflow-hidden text-ellipsis'
                  title={launch.name}
                >
                  {dayjs(launch.window_start).format('M/D')}: {launch.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpaceEventsDashboard;
